function DropdownIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 9.5L12 16.5L4 9.5" stroke="#464B50" strokeWidth="2" strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>
    );
}

export default DropdownIcon;
